<!-- <div class="app-container">
  <app-navbar-agent></app-navbar-agent>
  <app-sidebar-agent></app-sidebar-agent>
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
</div> -->

<div class="app-container">
  <!-- Navbar: Emits the search event -->
  <app-navbar-agent></app-navbar-agent>
  
  <!-- Sidebar (unchanged) -->
  <app-sidebar-agent></app-sidebar-agent>
  
  <!-- Content Component: Receives phoneNumberSearchQuery -->
  <div class="content-container">
    <router-outlet></router-outlet>
    <!-- <app-content-agent></app-content-agent> -->
  </div>
</div>
